import React from 'react';
import CoursesView from './CoursesView';

const CoursesContainer = (props) => {
  return <CoursesView {...props} />;
};

export default CoursesContainer;
